import { Tooltips } from '@printos/agnostic-tooltips';

// Configure for PrintOS tooltips as required by framework-agnostic components including view nav
export default function configPrintOSTooltips() {
  'ngInject';

  let tooltips = new Tooltips();
  tooltips.addObserver();
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/core/tooltips.config.js